import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, ApiClientService } from './api-client.service';
import { AP_API_CHECK_ROUTE_ACCESS } from '../constants';

interface CheckRouterAccessResponse extends ApiResponse {
  redirectUrl: string;
  access: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RouterAccessService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AP_API_CHECK_ROUTE_ACCESS);
  }

  checkRouteAccess(url: string): Observable<CheckRouterAccessResponse> {
    return this.get({ route: url });
  }
}

export { CheckRouterAccessResponse };
